// extracted by mini-css-extract-plugin
module.exports = {"root":"Options_root__1ME5G"};